'use strict';

//
// << Autogenerated, do not edit. All changes will be undone. >>
//
// The Program is owned by IBM or an IBM supplier, and is copyrighted and licensed, not sold.
//
// @author ISC Carlos Ernesto Islas Garcia <cernesto@mx1.ibm.com>
// @version 15 Feb 2017
// @licensed
//
(function init(define) {
  define([
    'app/app',
    'promise!utils/RequestTypes',
    'libs/q/q',
    'kendo/kendo.data.min',
  ], function define(Application, requestTypesObject, q, kendo) {
    // URLs to different services.
    var URL = Object.freeze({
      // User.
      userProfile: './bluepages/profiles/',
      userAvatar: '/image/profile/{uid}?def=avatar&type=bp',
      // Attachments.
      retrieveAttachments: 'core/default/serviceRequest/attachments/{requestIdAlias}/{engagementId}',
      attachmentReferenceNumber: 'core/default/upload/retrieveNewReferenceId/',
      saveAttachments: 'core/default/upload',
      deleteAttachments: 'core/default/upload/delete',
      /*
       * URL to the server's current date and time. Includes user's time zone.
       * Example response: { "date": "2017-02-15T18:40:37.823Z", "timezone": "America/Mexico_City", }
       */
      now: './core/time/now',
      // Opportunities.
      opps: 'core/opps',
      squads: './core/api/v1/squads?active=Y',
      requests: 'core/api/v2/requests',
      saveAsDraft: 'core/api/v2/requests/draft',
      resaveAsDraft: 'core/api/v2//requests/{requestId}/draft',
      legacy: {
        requests: 'core/default/serviceRequest',
        saveAsDraft: 'core/default/serviceRequest/draft',
      },
    });

    var Messages = Object.freeze({
      draftSaved: 'Request {id} was successfully saved',
    });

    var Catalogs = Application.utils.catalogs;
    var Geography = Application.utils.geographyFunctions.getGeography();

    const currentMarkets = Geography.usMarket;
    Geography.usMarket = currentMarkets.filter(market => {
      return !market.toBeDeleted;
    });
    
    var DEALDESK_FILTER = [
      'geo',
      'market',
      'countryCode',
      'unit',
      'subUnit',
      'channel',
      'engagementOption',
      'requestType',
      'requestGroup',
      'accelerate',
      'visible',
    ];
    const DEALDESK_FILTER_DFLT = [
      'geo',
      'market',
      'countryCode',
      'unit',
      'subUnit',
      'channel',
      'engagementOption',
    ];
    var DEALDESK_ATTRIBUTES_MAP = {
      geo: 'geo',
      market: 'market',
      countryCode: 'countryCode',
      unit: 'unit',
      subUnit: 'subUnit',
      channel: 'channel',
      engagementOption: 'engagementOption',
      requestType: 'requestType',
      requestGroup: 'requestGroup',
      accelerate: 'accelerate',
    };
    var PROGRAMTYPE_FILTER = [
      'requestType',
    ];

    function roundDate(date) {
      date.setSeconds(0);
      return date;
    }

    function filterAccelerateFieldWithFlag(field) {
      return !field.flagName || !!App[field.flagName] === field.showWithFlag;
    }

    function _createOrthogonalAttributesObject(model) {
      var key;
      var data = {};
      var orthogonalMap = DEALDESK_ATTRIBUTES_MAP;
      for (key in orthogonalMap) {
        if (orthogonalMap.hasOwnProperty(key)) {
          // is some of the values is empty, unload the current form
          // Ignore sub-units where is not needed
          if (!model[key] && (key !== 'subUnit' || model.hasSubUnits)) {
            data[orthogonalMap[key]] = '';
          }

          data[orthogonalMap[key]] = model[key];
        }
      }

      return data;
    }

    function _getRequestTypes(requestTypes) {
      _.each(requestTypesObject, function each(item) {
        var group = item.requestGroup;
        if (item.accelerate) {
          if (requestTypes[group].data.length > 0) {
            var added = false;
            for (var i = 0; i < requestTypes[group].data.length; i++) {
              var dataItem = requestTypes[group].data[i];
              added = dataItem.value === item.value;
              if (added) break;
            }
            if (!added) {
              requestTypes[group].data.push(_(item).clone());
            }
          } else {
            requestTypes[group].data.push(_(item).clone());
          }
        }
      });
    }

    Application.module('CommonData', function module(Module, Application, Backbone, Marionette, $, _) {
      Module.US_FEDERAL = 'US Federal';

      Module.getAccelerateRequestTypes = function getAccelerateRequestTypes() {
        var requestTypes = {
          'Demand Management': {
            color: '#296CC8',
            data: [],
          },
          'Configure, Price and Quote': {
            color: '#3A5D8C',
            data: [],
          },
          'Create and Manage Contracts': {
            color: '#01B560',
            data: [],
          },
          'Collect Cash': {
            color: '#00967C',
            data: [],
          },
          'Q2C Others': {
            color: '#DEDBD7',
            data: [],
          },
        };
        try {
          _getRequestTypes(requestTypes);
        } catch (error) {
          // does nothing... yet!
        }
        return requestTypes;
      };

      /*
       * Returns a kendo data source with an ascending list of all custom fields of the kind
       * [ { text: '...', value: '...', }, ... ].
       */
      Module.getCustomFields = function getCustomFields() {
        return new kendo.data.DataSource({
          data: Catalogs.customFields,
          sort: { field: 'text', dir: 'asc', },
          schema: { model: { id: 'value', }, },
        });
      };

      /*
       * Returns a kendo data source with an ascending list of all countries.
       * [ { text: 'Mexico', value: 'MX', ... }, ]
       */
      Module.getCountries = function getCountries() {
        return new kendo.data.DataSource({
          data: Geography.allCountries,
          sort: { field: 'text', dir: 'asc', },
        });
      };

      Module.getChannels = function getChannels() {
        var channelSourceAccelerate = new kendo.data.DataSource({
          data: Catalogs.channel,
          sort: { field: 'text', dir: 'asc', },
        });
        channelSourceAccelerate.filter({ field: 'value', operator: 'neq', value: 'INT', });
        return channelSourceAccelerate.view();
      };

      /*
       * Creates a kendo data source containing all channel codes´ information belonging to the channel with the passed-
       * channel ID.
       */
      Module.getChannelCodes = function getChannelCodes(channelId) {
        var codes = [];
        _.each(Catalogs.channelCodes, function each(channelCode) {
          if (channelCode.channel === channelId && channelCode.isActive) {
            codes.push(_(channelCode).clone());
          }
        });
        return new kendo.data.DataSource({
          data: codes,
          sort: { field: 'value', dir: 'asc', },
        });
      };

      Module.getUnits = function getUnits() {
        return new kendo.data.DataSource({
          data: Catalogs.units.filter(filterAccelerateFieldWithFlag),
          sort: { field: 'text', dir: 'asc', },
          filter: [ { field: 'value', operator: 'neq', value: 'IGF', }, ],
        });
      };

      Module.getProgramTypes = function getProgramTypes(model) {
        var programTypeSource = new kendo.data.DataSource({
          data: Catalogs.programType,
          sort: { field: 'text', dir: 'asc', },
        });
        var attributes = model && model.attributes ? model.attributes : model;
        var data = _createOrthogonalAttributesObject(attributes);
        var programTypeFilter = Application.utils.getDataSourceFilter(data, PROGRAMTYPE_FILTER);

        programTypeSource.filter(programTypeFilter);
        if (programTypeSource.view().length === 0) {
          programTypeSource.filter({ field: 'geo', operator: 'eq', value: 'ALL', });
          programTypeSource.filter({ field: 'market', operator: 'eq', value: 'ALL', });
          programTypeSource.filter({ field: 'countryCode', operator: 'eq', value: 'ALL', });
          programTypeSource.filter({ field: 'channel', operator: 'eq', value: 'ALL', });
          programTypeSource.filter({ field: 'unit', operator: 'eq', value: 'ALL', });
          programTypeSource.filter({ field: 'subUnit', operator: 'eq', value: 'ALL', });
        }
        return programTypeSource;
      };

      /*
       * Returns a list of subunits. Depending on the parameter this function
       * can return a plain JSON object, a Backbone Collection or a Kendo
       * data source.
       */
      Module.getSubunits = function getSubunits(type) {
        var subunits = _(Catalogs.subunits).clone();
        switch (type) {
          case 'backbone':
          case 'collection':
            return new Backbone.Collection(subunits);
          case 'dataSource':
          case 'datasource':
          case 'kendo':
            return new kendo.data.DataSource({
              data: Catalogs.subunits,
              sort: { field: 'text', dir: 'asc', },
            });
          default:
            return subunits;
        }
      };

      /*
       * Returns user's information.
       */
      Module.getUser = function getUser() {
        return Application.getConfig().user;
      };

      Module.getMarkets = function getMarkets() {
        var marketKeys = {};
        var markets = [];
        _.each(Geography.allCountries, function (country) {
          marketKeys[country.market] = true;
        });
        _.each(_.keys(marketKeys), function (market) {
          markets.push({ value: market, text: market, });
        });
        return new kendo.data.DataSource({
          data: markets,
          sort: { field: 'text', dir: 'asc', },
        });
      };

      Module.getUSMarkets = function getUSMarkets() {
        var markets = [];
        _.each(Geography.usMarket, function iterateUsCountries(country) {
          markets.push({ value: country.market, text: country.market, marketCode: country.marketCode, });
        });
        return new kendo.data.DataSource({
          data: markets,
        });
      };

      /*
       * Returns a kendo data source with an ascending list of all squads. The called service will return a structure --
       * like the following:
       * {
       *   data: [
       *      {
       *        id: 'xxx',
       *        attributes: {
       *           active: 'Y|N', genericSquad: 'Y|N', squadName: 'abc", ...
       *        }
       *      }
       *   ]
       * }
       */
      Module.getSquads = function getSquads() {
        var deferred = q.defer();
        Application.RestClient.get(URL.squads, function callback(error, response) {
          var squads = [];
          if (error) {
            deferred.reject(error);
          } else {
            _.each(response.data.data, function each(item) {
              var attributes = item.attributes;
              squads.push({
                squadId: item.id,
                active: attributes.active,
                squadName: attributes.squadName,
                genericSquad: attributes.genericSquad,
              });
            });
            deferred.resolve(new kendo.data.DataSource({
              data: squads,
              sort: { field: 'squadName', dir: 'asc', },
              filter: { field: 'active', operator: 'eq', value: 'Y', },
            }));
          }
        });
        return deferred.promise;
      };

      Module.attachmentReferenceNumber = function attachmentReferenceNumber(length) {
        var deferred = q.defer();
        var path = [ URL.attachmentReferenceNumber, (length || 0), ].join('');
        Application.RestClient.get(path)
        .then(function then(response) {
          deferred.resolve(response.data);
        })
        .fail(function fail() {
          deferred.reject();
        });
        return deferred.promise;
      };

      /*
       * Returns an object with the current date and time of the server.
       * If server's current date and time are not available, then the
       * local information is returned.
       */
      Module.now = function now() {
        var deferred = q.defer();
        var now;
        Application.RestClient.get(URL.now)
        .then(function then(response) {
          now = roundDate(new Date(response.data.date));
          deferred.resolve({
            now: now,
            date: kendo.toString(now, 'MM/dd/yyyy').split('/'),
            time: kendo.toString(now, 'HH:mm').split(':'),
          });
        })
        .fail(function fail() {
          now = roundDate(new Date());
          deferred.resolve({
            now: now,
            date: kendo.toString(now, 'MM/dd/yyyy').split('/'),
            time: kendo.toString(now, 'HH:mm').split(':'),
          });
        });
        return deferred.promise;
      };

      Module.getEngagementOptionById = function getEngagementOptionById(id) {
        var options = Catalogs.engagementOptions;
        var length = options.length;
        var option;
        var index;
        for (index = 0; index < length; index += 1) {
          option = options[index];
          if (option.id === id) {
            return option;
          }
        }
        return null;
      };

      /*
       * This array of property names is used for backward compatibility with RequestConfirmation module. It is used to-
       * map existing property names to be compatible with property names used in the aforementioned module.
       */
      Module.ConfirmationProperties = [
        {
          origin: [ 'etNo', 'engagementId', ],
          target: 'etNo',
        },
        {
          origin: [ 'srNoAlias', 'requestId', 'requestIdAlias', ],
          target: 'srNoAlias',
        },
        {
          origin: [ 'engagementOption', ],
          target: 'engagementOptionDescription',
        },
        {
          origin: [ 'requestType', ],
          target: 'requestType',
        },
        {
          origin: [ 'idReqtype', 'requestTypeImageId', ],
          target: 'idReqtype',
        },
        {
          origin: [ 'dueDate', ],
          target: 'formattedDueDate',
        },
        {
          origin: [ 'requestorNotesId', 'requestedByNotesId', 'requestor', 'requestedBy', ],
          target: 'requestorId',
        },
        {
          origin: [ 'description', ],
          target: 'description',
        },
        {
          origin: [ 'clientName', 'customerName', ],
          target: 'opportunity_clientName',
        },
        {
          origin: [ 'custNo', 'customerNumber', ],
          target: 'opportunity_customerNo',
        },
        {
          origin: [ 'oppId', 'hasOpportunity', ],
          target: 'hasOpportunityNo',
        },
        {
          origin: [ 'oppDescription', 'opportunityDescription', ],
          target: 'opportunity_description',
        },
        {
          origin: [ 'oppOwnerNotesId', 'opportunityOwnerNotesId', ],
          target: 'oppOwnerNotesId',
        },
        {
          origin: [ 'oppId', 'opportunityNumber', ],
          target: 'opportunityNo',
        },
        {
          origin: [ 'country', ],
          target: 'opportunity_country',
        },
        {
          origin: [ 'unit', ],
          target: 'unit',
        },
        {
          origin: [ 'subUnit', ],
          target: 'opportunity_subUnit',
        },
        {
          origin: [ 'generic', ],
          target: 'generic',
        },
      ];

      Module.createEmptyDataSource = function createEmptyDataSource() {
        return new kendo.data.DataSource({
          data: [
            // empty
          ],
        });
      };

      Module.getDealDesks = function getDealDesks(model) {
        var dealDeskSource = new kendo.data.DataSource({
          data: Catalogs.dealDesk,
          sort: { field: 'text', dir: 'asc', },
        });
        var attributes = model && model.attributes ? model.attributes : model;
        var data = _createOrthogonalAttributesObject(attributes);
        data.visible = true;
        var dealDeskFilter = Application.utils.getDataSourceFilter(data, DEALDESK_FILTER);

        dealDeskSource.filter(dealDeskFilter);
        if (dealDeskSource.view().length === 0) {
          dealDeskSource.filter({});
        }
        return dealDeskSource;
      };

      Module.getDealDesksDflt = function getDealDesksDflt(model) {
        const dealDeskSource = new kendo.data.DataSource({
          data: Catalogs.dealDesk,
          sort: { field: 'text', dir: 'asc', },
        });
        const attributes = model && model.attributes ? model.attributes : model;
        const data = _createOrthogonalAttributesObject(attributes);
        data.visible = true;
        const dealDeskFilterDflt = Application.utils.getDataSourceFilter(data, DEALDESK_FILTER_DFLT);
        dealDeskSource.filter(dealDeskFilterDflt);
        return dealDeskSource;
      };

      Module.getAccelerateSubunits = function getSubunits(type) {
        var subunits = _(Catalogs.subunits).filter(filterAccelerateFieldWithFlag);
        switch (type) {
          case 'backbone':
          case 'collection':
            return new Backbone.Collection(subunits);
          case 'dataSource':
          case 'datasource':
          case 'kendo':
            return new kendo.data.DataSource({
              data: subunits,
              sort: { field: 'text', dir: 'asc', },
            });
          default:
            return subunits;
        }
      };

      // Expose URLs.
      Module.URL = URL;

      Module.Messages = Messages;
    });

    return Application.CommonData;
  });
}(define));
